import {
  CommercialDocumentFileSignedSchema,
  CommercialDocumentHistorySchema,
  CommercialDocumentListSchema,
  CommercialDocumentResponseSchema,
  CommercialDocumentSaveSchema,
  type CommercialDocumentInput,
} from "../../shared/commercial-documents";
import { parseResponse } from "../api/client-core";

const root = (slug: string) =>
  `/api/ops/customers/${encodeURIComponent(slug)}/commercial-documents`;
const json = (method: string, body: unknown): RequestInit => ({
  method,
  credentials: "same-origin",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(body),
});
export async function listCommercialDocuments(slug: string, search = "", cursor?: string) {
  return parseResponse(
    await fetch(`${root(slug)}?${new URLSearchParams({ search, ...(cursor ? { cursor } : {}) })}`, {
      credentials: "same-origin",
    }),
    CommercialDocumentListSchema,
  );
}
export async function getCommercialDocument(slug: string, id: string, revision?: number) {
  return parseResponse(
    await fetch(
      `${root(slug)}/${encodeURIComponent(id)}${revision ? `?revision=${revision}` : ""}`,
      { credentials: "same-origin" },
    ),
    CommercialDocumentResponseSchema,
  );
}
export async function getCommercialHistory(slug: string, id: string, before?: number) {
  return parseResponse(
    await fetch(
      `${root(slug)}/${encodeURIComponent(id)}/history${before ? `?before=${before}` : ""}`,
      { credentials: "same-origin" },
    ),
    CommercialDocumentHistorySchema,
  );
}
export async function saveCommercialDocument(
  slug: string,
  id: string,
  input: {
    document: CommercialDocumentInput;
    expectedRevision: number;
    changeNote: string;
  },
) {
  return parseResponse(
    await fetch(
      `${root(slug)}/${encodeURIComponent(id)}`,
      json("PUT", CommercialDocumentSaveSchema.parse(input)),
    ),
    CommercialDocumentResponseSchema,
  );
}
export async function restoreCommercialDocument(
  slug: string,
  id: string,
  input: {
    expectedRevision: number;
    revision: number;
  },
) {
  return parseResponse(
    await fetch(`${root(slug)}/${encodeURIComponent(id)}/restore`, json("POST", input)),
    CommercialDocumentResponseSchema,
  );
}
export async function fileSignedCommercialDocument(
  slug: string,
  id: string,
  input: { revision: number; fileId: string; signedOn: string },
) {
  return parseResponse(
    await fetch(
      `${root(slug)}/${encodeURIComponent(id)}/file`,
      json("POST", CommercialDocumentFileSignedSchema.parse(input)),
    ),
    CommercialDocumentResponseSchema,
  );
}
